const dealAssignment = {
  id: null,
  dealId: null,
  employeeTypeId: null,
  corporateName: null,
  ein: null,
  payFrequencyId: null,
  contractTypeId: null,
  lengthOfContract: null,
  conversionFee: null,
  payRateTypeId: null,
  payRate: null,
  billRateTypeId: null,
  billRate: null,
  overtimeEligible: null,
  startAt: null,
  endAt: null,
  jobTitle: null,
  permPlacementDate: null,
  permPlacementSalary: null,
  permPlacementFee: null,
  permPlacementFeeTypeId: null,
  permPlacementNetFee: null,
  permPlacementInvoiceDate: null,
  permPlacementInvoiceDueDate: null,
  commissions: [],
  expenses: [],
  expensesDeduction: 0,
  expensesDeductionHint: null,
  workedHoursAverage: null,
  overtimeThreshold: null,
  overtimeRate: null,
  timeSheetType: 2,
  clockIPAddress: null
}

export default () => Object.assign({}, dealAssignment)
